import type { StandardApplicability } from '@/shared/hooks/api/machineryDirectiveCompliance'
import {
  isIso12100Reference,
  isTypeCStandard,
} from '../utils/standardKinds'

function machineryStandardTypeRank(type: string): number {
  const normalized = type.trim().toUpperCase()
  if (normalized === 'C') {
    return 0
  }
  if (normalized === 'B') {
    return 1
  }
  if (normalized === 'A') {
    return 2
  }
  return 3
}

function compareOnboardingReviewStandards(
  first: StandardApplicability,
  second: StandardApplicability
): number {
  const firstIsMandatory = isIso12100Reference(first.reference)
  const secondIsMandatory = isIso12100Reference(second.reference)
  if (firstIsMandatory && !secondIsMandatory) {
    return -1
  }
  if (!firstIsMandatory && secondIsMandatory) {
    return 1
  }
  const typeDiff =
    machineryStandardTypeRank(first.type) -
    machineryStandardTypeRank(second.type)
  if (typeDiff !== 0) {
    return typeDiff
  }
  return first.reference.localeCompare(second.reference)
}

export function sortStandardsForTypeCReview(
  standards: StandardApplicability[]
): StandardApplicability[] {
  return [...standards].sort(compareOnboardingReviewStandards)
}

export function sortOnboardingStandards(
  standards: StandardApplicability[]
): StandardApplicability[] {
  const onboardingStandards = standards.filter((standard) => {
    return (
      isTypeCStandard(standard.type) || isIso12100Reference(standard.reference)
    )
  })
  return sortStandardsForTypeCReview(onboardingStandards)
}
